// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ShopArticleTaxHistoryListResultModel from '../../model/shop-article-tax-history-list-result-model';
import ShopArticleTaxHistoryListResultDTO from '../dto/shop-article-tax-history-list-result-dto';
import dtoSchema from '../schemas/shop-article-tax-history-list-result-schema';
import ShopArticleTaxHistoryModel from '../../model/shop-article-tax-history-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class ShopArticleTaxHistoryListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ShopArticleTaxHistoryListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => ShopArticleTaxHistoryModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: ShopArticleTaxHistoryModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<ShopArticleTaxHistoryListResultDTO>): ShopArticleTaxHistoryListResultModel;
  static toModel(dto: DeepPartial<ShopArticleTaxHistoryListResultDTO> | undefined | null): ShopArticleTaxHistoryListResultModel | undefined;
  static toModel(dto: DeepPartial<ShopArticleTaxHistoryListResultDTO> | undefined | null): ShopArticleTaxHistoryListResultModel | undefined {
    return dto ? new ShopArticleTaxHistoryListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ShopArticleTaxHistoryListResultModel> | ShopArticleTaxHistoryListResultModel): ShopArticleTaxHistoryListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as ShopArticleTaxHistoryListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ShopArticleTaxHistoryListResultModel, can not map to ShopArticleTaxHistoryListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
